import React, { useState } from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Icon from '@nubank/nuds-web/components/Icon/Icon';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import styled from 'styled-components';

const StyledDisplaycontainer = styled(Box)`
  cursor: pointer;
`;
const bulletsText = [
  {
    id: '1',
    text: 'CREDIT_CARD.CARD.BULLETS_1',
  },
  {
    id: '2',
    text: 'CREDIT_CARD.CARD.BULLETS_2',
  },
  {
    id: '3',
    text: 'CREDIT_CARD.CARD.BULLETS_3',
  },
  {
    id: '4',
    text: 'CREDIT_CARD.CARD.BULLETS_4',
  },
];

const StyledTypography = styled(Typography)`
  @media (width >= 1150px) {
    font-size: 1.3rem;
  }
`;

const Collapsable = () => {
  const [isCollapsed, setCollapsed] = useState(false);

  return (
    <>
      <StyledDisplaycontainer
        display="flex"
        alignItems="center"
        paddingHorizontal={{ xs: '32px', lg: '100px' }}
        marginTop={{ xs: '60px', lg: '120px' }}
        marginBottom="32px"
        justifyContent={{ xs: 'left', lg: 'center' }}
        onClick={() => setCollapsed(!isCollapsed)}
      >
        <StyledTypography
          intlKey="CREDIT_CARD.CARD.BULLETS.TITLE"
          variant="heading4"
          strong
          marginRight="20px"
        />

        <Box>
          <Icon
            name={isCollapsed ? 'minus' : 'plus'}
            title={isCollapsed ? 'Mostrar menos' : 'Mostrar más'}
            size="default"
          />
        </Box>
      </StyledDisplaycontainer>

      { isCollapsed ? (
        <Box
          paddingHorizontal={{ xs: '32px', lg: '100px' }}
          display="flex"
          flexDirection="column"
          justifyContent="center"
        >
          <Typography
            intlKey="CREDIT_CARD.CARD.BULLETS.DESCRIPTION"
            variant="paragraph2"
            gutterBottom="2"
            marginTop="6x"
            textAlign={{ xs: 'left', lg: 'center' }}
          />

          {bulletsText.map(el => (
            <Box
              key={el.id}
              display="flex"
              justifyContent={{ xs: 'left', lg: 'center' }}

            >
              <Box
                tag="li"
              />
              <Typography
                tag="p"
                intlKey={el.text}
                variant="paragraph2"
                gutterBottom="2"
              />

            </Box>
          ))}
        </Box>
      ) : null }

    </>

  );
};

export default Collapsable;
